import { GlobalSignatureRequestsView } from "@/components/features/signature-request/GlobalSignatureRequestsView";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signature-requests")({
  component: RouteComponent,
  pendingComponent: () => (
    <div className="flex w-full">
      <LawWorksLoader className="w-full" />
    </div>
  ),
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.signatureRequestsAccess)) {
    return <GlobalNotAuthorized />;
  }

  return <GlobalSignatureRequestsView />;
}
